import {
    validateRequired, validateEmail, validateFnr, validateRoleArray, validateRole,
} from '../../../youwell-common/validationUtils';


export const defaultValidators = {
    name: validateRequired,
    email: [validateEmail, validateRequired],
};

export const getValidators = (clientConfig, newUser) => (
    {
        ...defaultValidators,
        fnr: [validateFnr, clientConfig.u_FnrLogin && validateRequired],
        phone: clientConfig.u_AnonymousOnly ? null : validateRequired,
        mappedRoles: newUser ? null : validateRoleArray,
        roleForNewUser: newUser ? validateRole : null,
    }
);
